import DxmlParagraph from "../DxmlParagraph"
import { useEditorFile } from "../../../../../hooks/useEditorFile";

export default function DxmlList({ editorList }) {
    const { getKeyById } = useEditorFile();

    if (editorList.IsNumberedList) {
        return (
            <div className="ql-editor">
                <ol style={editorList.ReactCssStyle}>
                    {editorList.Items.map((editorListItem) => (
                        <li key={getKeyById(editorListItem)} style={editorListItem.ReactCssStyle}>
                            {editorListItem.Items.map((editorParagraph, index) => (
                                <DxmlParagraph key={getKeyById(editorParagraph)} editorParagraph={editorParagraph} firstParagraphInList={(index === 0)} />
                            ))}
                        </li>
                    ))}
                </ol>
            </div>
        )
    }
    return (
        <div className="ql-editor">
            <ul style={editorList.ReactCssStyle}>
                {editorList.Items.map((editorListItem) => (
                    <li key={getKeyById(editorListItem)} style={editorListItem.ReactCssStyle}>
                        {editorListItem.Items.map((editorParagraph, index) => (
                            <DxmlParagraph key={getKeyById(editorParagraph)} editorParagraph={editorParagraph} firstParagraphInList={(index === 0)} />
                        ))}
                    </li>
                ))}
            </ul>
        </div>
    )
}